interface LegendItem {
  color: string;
  label: string;
  description: string;
}

export const LegendPanel = () => {
  const items: LegendItem[] = [
    {
      color: 'bg-emerald-500',
      label: 'Estoque Alvo',
      description: 'Nível ideal para cobertura planejada',
    },
    {
      color: 'bg-amber-500',
      label: 'ROP (Ponto de Pedido)',
      description: 'Momento de fazer novo pedido',
    },
    {
      color: 'bg-slate-400',
      label: 'Estoque de Segurança',
      description: 'Reserva para imprevistos',
    },
    {
      color: 'bg-blue-500',
      label: 'Água (Estoque Atual)',
      description: 'Quantidade disponível agora',
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5">
      <h3 className="text-sm font-semibold text-slate-900 mb-4">Como Interpretar</h3>
      <div className="space-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex items-start gap-3">
            <div className={`w-3 h-3 ${item.color} rounded-full mt-0.5 flex-shrink-0`} />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-slate-900">{item.label}</div>
              <div className="text-xs text-slate-500 mt-0.5">{item.description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5 pt-5 border-t border-slate-200">
        <div className="text-xs text-slate-600 space-y-2">
          <p>
            <span className="font-semibold text-slate-900">CMD</span> = Consumo Médio Diário
          </p>
          <p>
            <span className="font-semibold text-slate-900">LT</span> = Lead Time (prazo de entrega)
          </p>
          <p className="text-[11px] text-slate-500 mt-3 pt-3 border-t border-slate-100">
            Quando a água atinge o ROP, um novo pedido deve ser gerado considerando o Lead Time.
          </p>
        </div>
      </div>
    </div>
  );
};
